<template>
  <v-sheet
    class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4 as-box-title as-bg-color-100"
    elevation="4"
    height="150"
    rounded
    max-width="600"
    width="100%"
    mb="6"
  >
    <div>
      <div class="text-h5 font-weight-medium pa-2">
        DIRECCIÓN GENERAL LOGÍSTICA<br />UNIDAD DE MATERIAL BÉLICO
      </div>
      <p class="text-body-2 mb-4">
        Registro clasificado de armas de fuego, municiones y explosivos de uso
        Militar <br />
        -- CERTIFICACION CUCHILLO BAYONETA --
      </p>
    </div>
  </v-sheet>

  <div class="mx-5 my-5">
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          color="light-blue-darken-4"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="registros" :search="search">
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small @click="abrirDialogo(item)">
            Registrar y Certificar
          </v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogoAbierto" max-width="750px">
        <v-card>
          <v-card-title class="text-center">
            CONTENIDO INDIVIDUAL
          </v-card-title>
          <v-card-text>
            <div>
              <div>
                <strong>Número de Certificado:</strong> {{ numeroCertificado }}
              </div>
              <strong>Nombre y Apellido</strong> {{ nombre_completo }}
            </div>
            <div><strong>Cedula de Identidad:</strong> {{ carnet }}</div>
            <div><strong>codigo Persona:</strong> {{ codigo_persona }}</div>
            <div><strong># Cuchillo:</strong> {{ nro_cuchillo }}</div>
            <div><strong>Marca:</strong> {{ marca }}</div>
            <div><strong>Modelo:</strong> {{ modelo }}</div>

            <!-- Formulario para editar el nombre -->
            <v-form @submit.prevent="submitForm">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="carnet"
                    label="Carnet"
                    :rules="firstNameRules"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="codigo_persona"
                    label="Codigo Persona"
                    :rules="lastNameRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="nro_cuchillo"
                    label="# Cuchilo"
                    :rules="lastNameRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="marca"
                    label="Marca"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="modelo"
                    label="Modelo"
                    :rules="lastNameRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="gestion_dotacion"
                    label="Gestion Dotacion"
                    :rules="lastNameRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="procedencia"
                    label="Procedencia"
                    :rules="lastNameRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="observaciones"
                    label="Observaciones"
                    :rules="lastNameRules"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" block class="mt-2">Guardar Cambios</v-btn>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="cerrarDialogo">Cerrar</v-btn>
            <!-- <v-btn text @click="registrarEnBaseDeDatos">Registrar</v-btn> -->
            <v-btn text @click="generarCertificacion">Certificar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { defineComponent } from "vue";
import SinCuchillos from "@/services/SinCuchillos";
import Reposiciones from "@/services/Reposiciones";
import { VDataTable, VCardTitle, VCard, VBtn } from "vuetify/labs/VDataTable";
import Usuario from "@/services/Usuario";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default defineComponent({
  name: "AdminPage",
  components: {
    VDataTable,
    VCard,
    VCardTitle,
    VBtn,
  },
  data() {
    return {
      codigo_persona: "", 
      nro_cuchillo: "",
      marca: "",
      modelo: "",
      gestion_dotacion: "",
      procedencia: "",
      observaciones: "",
      registros: [],
      usuario: [],
      sincuchillo: new SinCuchillos(),
      usuariosPorRol: [], // Variable para almacenar la información de los usuarios por rol
      rolId: 12,
      rolId2: 11,
      cedula: "",
      search: "",
      fecha: "",
      qrCodeData: "",
      dialogoAbierto: false,
      carnet: "",
      nombre_completo: "",
      nombres: "",
      numeroCertificado: "",
      headers: [
        {
          key: "carnet",
          title: "CEDULA DE IDENTIDAD",
        },
        {
          key: "nombre_completo",
          title: "NOMBRES Y APELLIDOS",
        },
        {
          key: "actions",
          title: "ACCIONES",
          align: "center",
        },
      ],
    };
  },
  methods: {
    abrirDialogo(item) {
      this.carnet = item.carnet;
      this.nombre_completo = item.nombre_completo;
          console.log("es el nombre", this.nombre_completo);
      this.dialogoAbierto = true;
    },
    cerrarDialogo() {
      this.dialogoAbierto = false;
      },
    limpiarFormulario() {
            this.codigo_persona = "";
            this.nro_cuchillo = "";
            this.marca = "";
            this.modelo = "";
            this.gestion_dotacion = "";
            this.procedencia = "";
            this.observaciones = "";
        },
    async submitForm() {
      try {
        const reposicioncuchillo = new Reposiciones();
        const cuchillopost = {
          carnet: this.carnet,
          codigo_persona: this.codigo_persona,
          nro_cuchillo: this.nro_cuchillo,
          marca: this.marca,
          modelo: this.modelo,
          gestion_dotacion: this.gestion_dotacion,
          procedencia: this.procedencia,
          observaciones: this.observaciones,
        };

        // Llama al servicio para guardar los datos
        const response = await reposicioncuchillo.saveCuchilloReposicion(
          cuchillopost
        );
        if (response.status === true) {
            console.log("Datos guardados exitosamente:", response);
          this.limpiarFormulario();
          this.cerrarDialogo();
        } else {
          console.error("Error al guardar los datos:", response);
        }
      } catch (error) {
        console.error("Error en la función submitForm:", error);
      }
    },
    async indexDB() {
      try {
        const respuesta = await this.sincuchillo.index();
        if (respuesta.status) {
          this.registros = respuesta.records;
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    },
    async obtenerNumeroMaximo() {
      try {
        const sinCuchillos = new SinCuchillos();
        const response = await sinCuchillos.obtenerNumeroMaximo();
        //console.log("Este es la respuesta del num max",response );
        return response;
      } catch (error) {
        console.error("Error al obtener el número máximo:", error);
        throw error;
      }
      },
      async registrosreposicion() {
          try {
            const reposicionlista = new Reposiciones();
              const response = await reposicionlista.listareposicioncuchillo();
              console.log("Es mi lista de reposiciones", response);
              this.registros = response;
            
          } catch (error) {
                console.error("Error al obtener el número máximo:", error);
                throw error;
            }
    },

    async generarCertificacion() {
      const options = { day: "2-digit", month: "long", year: "numeric" };
      this.fecha = new Date().toLocaleDateString("es-ES", options);

      const numeroMaximo = await this.obtenerNumeroMaximo();
      console.log("Este es la respuesta del num max", numeroMaximo);
      this.numeroCertificado = numeroMaximo;

      const qrCodeData = `CERTIFICADO de reposicion de pistola N° UMB-${this.numeroCertificado}/2023\n perteneciente a: ${this.nombre_completo}\nes extendido en fecha ${this.fecha}`;
      const qrCodeImageDefinition = {
        qr: qrCodeData,
        fit: 100,
        alignment: "right",
        width: "auto",
        margin: [0, 10, 5, 0],
      };

      const documentDefinition = {
        content: [
          qrCodeImageDefinition,

          {
            text: `CERTIFICADO DE RESARCIMIENTO N° UMB-${this.numeroCertificado}/2023`,
            style: "header",
            alignment: "center",
            margin: [0, 0, 0, 0],
          },
          {
            text: "La Unidad de Material Bélico del Ministerio de Defensa, en atención a la solicitud presentada por el Interesado:",
            style: "body", // Puedes definir un estilo específico para este texto si lo deseas.
            margin: [35.05, 10, 35.05, 0], // Ajusta el margen superior según tus necesidades.
          },
          {
            text: "C E R T I F I C A:",
            style: "subheader", // Puedes definir un estilo específico para este texto si lo deseas.
            margin: [45.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
            bold: true,
          },
          {
            text: `Al Señor: ${this.nombre_completo}\n con Cedula de Identidad: ${this.carnet}`,
            style: "body",
            alignment: "center",
            margin: [0, 0, 0, 20],
          },
          {
            text: `EL DEPÓSITO BANCARIO EN LA CUENTA\n(VARIOS) DEL  MINISTERIO DE DEFENSA. Nº 1-24276087\nREGISTRÓ DE TESORERÍA Nº 74590\nREGISTRO DE RUBRO Nº 15990.`,
            style: "subheader",
            alignment: "center",
          },
          {
            text: "Realizó el RESARCIMIENTO ECONÓMICO por concepto de 1 (Un) Cuchillo\n Bayoneta deacuerdo al siguiente detalle:",
            style: "body",
            margin: [35.05, 10, 35.05, 0],
          },
          {
            text: "CUCHILLO BAYONETA:",
            style: "subheader", // Puedes definir un estilo específico para este texto si lo deseas.
            margin: [45.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
            bold: true,
          },
          {
            text: " DESCRIPSIÓN\nMODELO\nSERIE\nINDUSTRIA",
            style: "body", // Puedes definir un estilo específico para este texto si lo deseas.
            margin: [200.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
          },
          {
            text: "Advertencia",
            style: "body",
            margin: [35.05, 10, 35.05, 0],
            bold: true,
          },
          {
            text: "-	El presente Certificado es válido solo para trámites administrativos dentro las FF.AA.\n-	Cualquier alteración, borrón, raspadura o enmienda, anula el presente Certificado.",
            style: "body",
            margin: [35.05, 10, 35.05, 0],
            fontSize: 10,
            bold: true,
          },
          {
            text: `La Paz, ${this.fecha}`, // Aquí se utiliza la propiedad fecha
            style: "subheader",
            alignment: "right",
            fontSize: 12,
            margin: [35.05, 10, 35.05, 0],
          },
          {
            text: `${this.firma1}`,
            style: "subheader",
            alignment: "center",
            fontSize: 12,
            margin: [-230, 60, 35, 50],
          },
          {
            text: `JEFE DE UNIDAD`,
            style: "subheader",
            alignment: "center",
            bold: true,
            fontSize: 12,
            margin: [-230, -50, 35, 50],
          },
          {
            text: `${this.firma2}`,
            style: "subheader",
            alignment: "center",
            fontSize: 12,
            margin: [250, -80, 35, 50],
          },
          {
            text: `DIRECTOR GENERAL DE LOGÍSTICA`,
            style: "subheader",
            alignment: "center",
            bold: true,
            fontSize: 12,
            margin: [250, -50, 35, 50],
          },
          // Agrega más contenido según sea necesario
        ],

        styles: {
          header: {
            fontSize: 16,
            bold: true,
            margin: [0, 56.7, 0, 20],
          },
          subheader: {
            fontSize: 14,
            margin: [0, 0, 0, 10],
          },
          body: {
            fontSize: 12,
          },
        },
      };

      // Genera y descarga el PDF
      pdfMake.createPdf(documentDefinition).open();
    },
    async registrarEnBaseDeDatos() {
      try {
        // Obtén el número máximo actual antes de certificar
        const numeroMaximo = await this.obtenerNumeroMaximo();

        // Envía una solicitud al backend para certificar y actualizar el número máximo
        const response = await this.sincuchillo.certificar({ numeroMaximo });

        // Actualiza el número máximo localmente si la solicitud fue exitosa
        if (response && response.data && response.data.nuevoNumeroMaximo) {
          this.numeroCertificado = response.data.nuevoNumeroMaximo;
        }

        console.log("Número de certificado registrado en la base de datos");
      } catch (error) {
        console.error("Error al registrar en la base de datos:", error);
      }
    },
  },
  async created() {
    try {
      this.registros = await this.sincuchillo.index();
      const firmasrol = new Usuario();

      // Obtener usuarios por el primer rol (roleId = 11)
      const roleId1 = 11;
      const response1 = await firmasrol.obtenerUsuariosPorRol(roleId1);

      console.log("Este es mi respuesta de Usuario para roleId1", response1);

      if (response1 && response1.length > 0) {
        const primerusuario1 = response1[0].nombres;
        console.log("Este es mi primerusuario para roleId1", primerusuario1);
        this.firma1 = primerusuario1;
        console.log("Esta es la firma para roleId1", this.firma1);
      } else {
        console.error(
          "La respuesta del servicio para roleId1 no contiene datos"
        );
      }

      // Obtener usuarios por el segundo rol (roleId = 12)
      const roleId2 = 12;
      const response2 = await firmasrol.obtenerUsuariosPorRol(roleId2);

      console.log("Este es mi respuesta de Usuario para roleId2", response2);

      if (response2.length > 0) {
        const primerusuario2 = response2[0].nombres;
        console.log("Este es mi primerusuario para roleId2", primerusuario2);
        this.firma2 = primerusuario2;
        console.log("Esta es la firma para roleId2", this.firma2);
      } else {
        console.error(
          "La respuesta del servicio para roleId2 no contiene datos"
        );
      }
    } catch (error) {
      console.error("Error al obtener usuarios por rol:", error);
    }
  },
});
</script>
